/**
 * Tree for browsing the directory structure of an artifact.
 */
import TreeItem from '@material-ui/lab/TreeItem';
// @todo: Migrate to 'TreeView' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import TreeView from '@material-ui/lab/TreeView';
// @todo: Migrate to 'Icon' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {IconDocument, IconFolderAlt} from '@wandb/weave/components/Icon';
import React from 'react';

// eslint-disable-next-line import/no-cycle -- please fix if you can
import {TreeNode} from './ArtifactFiles';

export type ArtifactFilesTreeProps = {
  tree: any;
  selected: string;
  onSelect?: (path: string) => void;
};

const getTreeItems = (node: TreeNode) => {
  const nodeId = '/' + node.path.join('/');
  const folders = node.folders
    ? Object.keys(node.folders)
        .sort()
        .map(key => node.folders[key])
    : [];
  const files = node.files
    ? Object.keys(node.files)
        .sort()
        .map(key => node.files[key])
    : [];
  const icon =
    node.folders || node.files ? <IconFolderAlt /> : <IconDocument />;
  return (
    <TreeItem key={nodeId} nodeId={nodeId} label={node.label} icon={icon}>
      {folders.map(folder => getTreeItems(folder))}
      {files.map(file => getTreeItems(file))}
    </TreeItem>
  );
};

export const ArtifactFilesTree = ({
  tree,
  selected,
  onSelect,
}: ArtifactFilesTreeProps) => {
  return (
    <TreeView
      defaultExpanded={['/']}
      selected={selected}
      onNodeSelect={(e: React.ChangeEvent<{}>, value: string) =>
        onSelect && onSelect(value)
      }>
      {getTreeItems(tree)}
    </TreeView>
  );
};
